<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
	export default {
		name: 'app',
		data() {
			return {
				tokenCheckInterval: null
			}	
		},
		mounted() {
			// 仅在非移动设备上设置Token检查
			if (!this.$isMobile) {
				// 设置Token检查定时器
				this.startTokenCheck();
				
				// 监听页面可见性变化
				document.addEventListener('visibilitychange', this.handleVisibilityChange);
			}
		},
		methods: {
			// 启动定时检查Token
			startTokenCheck() {
				// 如果是移动设备，不启动检查
				if (this.$isMobile) return;
				
				// 清除已有定时器
				if (this.tokenCheckInterval) {
					clearInterval(this.tokenCheckInterval);
				}
				
				// 设置新的定时器 - 每分钟检查一次
				this.tokenCheckInterval = setInterval(() => {
					this.checkTokenValidity();
				}, 60000); // 60秒
			},
			
			// 检查Token有效性
			checkTokenValidity() {
				// 如果是移动设备，不检查Token
				if (this.$isMobile) return;
				
				// 从Vue原型上调用checkToken方法
				if (this.checkToken && typeof this.checkToken === 'function') {
					this.checkToken();
				}
			},
			
			// 处理页面可见性变化 - 用户重新回到页面时检查登录状态
			handleVisibilityChange() {
				// 如果是移动设备，不进行处理
				if (this.$isMobile) return;
				
				if (!document.hidden) {
					// 页面变为可见状态时立即检查一次Token
					this.checkTokenValidity();
				}
			}
		},
		beforeDestroy() {
			// 如果是移动设备，不需要清理
			if (this.$isMobile) return;
			
			// 清除定时器
			if (this.tokenCheckInterval) {
				clearInterval(this.tokenCheckInterval);
			}
			
			// 移除事件监听
			document.removeEventListener('visibilitychange', this.handleVisibilityChange);
		}
	}
</script>
<style>

	#app{
		background: #fff;
	}
	.flex {
  display: flex;
}
.fc {
  display: flex;
  align-items: center;
}
.f-h{
	display: flex;
	flex-direction: column;
}
.fc-h{
	display: flex;
	flex-direction:column;
	align-items: center;
}
.fcc-h{
	display: flex;
	flex-direction: column;
	align-items: center;justify-content: center;
}
.fcc {
  display: flex;
  align-items: center;
  justify-content: center;
}
.fc-bet {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.flex1 {
  flex: 1;
}
.f-pr {
  position: relative;
}
.modal-backdrop.show{
	z-index: 123456789;
}
.modal.show{
	z-index: 1234567890;
}
label.form-check-label {
	position: relative;
	top: 2px;
}
span.form-check-label{
	padding-top: 0;
	font-size: 12px;
	position:absolute;
	right: 10px;
	top	: 50%;
	transform: translateY(-50%);
	white-space: nowrap;
}




::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

::-webkit-scrollbar-thumb {
    background: #ccc; 
    border-radius: 5px; 
}

::-webkit-scrollbar-thumb:hover {
    background: #524036;
}

.img-fluid{
	max-height: 70vh;
	object-fit: contain;
}

@media (max-width: 768px) {
	.accordion-item *{
		font-size: 16px!important;
	}
}
</style>
